import { RouteRecordRaw } from 'vue-router';

const humanResourceRoutes: Array<RouteRecordRaw> = [
  {
    path: 'human-resource/jobs-titles',
    component: () =>
      import('@/app/human-resource/components/job-titles-index-component.vue'),
    name: 'app.human-resource.job-titles',
  },
  {
    path: 'human-resource/job-applicants',
    component: () =>
      import(
        '@/app/human-resource/components/job-applicants/job-applicants-index.vue'
      ),
    name: 'app.human-resource.job-applicants',
  },
  {
    path: 'human-resource/mentor-titles',
    component: () =>
        import('@/app/human-resource/components/mentor-titles-index-component.vue'),
    name: 'app.human-resource.mentor-title',
  },
  {
    path: 'human-resource/mentor-applicants',
    component: () =>
        import(
            '@/app/human-resource/components/mentor-applicants/mentor-applicants-index.vue'
            ),
    name: 'app.human-resource.mentor-applicants',
  },
];

export default humanResourceRoutes;
